import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import checkboxHOC from "react-table/lib/hoc/selectTable";
import ReactTable from "react-table";
import Modal from 'react-modal'
import { get, postWithHeaders, postWithHeadersResponse } from "../../../server/actions";
import { currency_symbol, URL_VERSION, date_format, URL_VERSION3 } from '../../../server/constants'
import $ from 'jquery'
import Datetime from 'react-datetime'
import '../../../../node_modules/react-datetime/css/react-datetime.css'
import PropTypes from "prop-types";
import { BeatLoader } from 'react-spinners';
import NotificationSystem from 'react-notification-system';
import {
    _addNotification, _addNotificationError, getGradeIndexValue, isRegularLunchOrderType,
    standardDateFormat, convertTwoDecimalPoint, getGradeIndex, isInt, getSchoolGrades, groupBy, getModuleEnum, getAccessLevelByModule, getSalesTaxStatus, numberParce
} from '../../../server/util'
import '../../../assets/css/fullcalendar.min.css'
import 'react-big-calendar/lib/less/month.less'
import '../../../assets/css/react-big-calendar.css'
import 'react-big-calendar/lib/less/styles.less'
import MenuComponent from '../Menu/menuComponent'
import moment from "moment/moment";
import MenuOptions from '../../Misc/MenuOptions/menuOptions';
import { getOrderMenuOptions } from '../../Misc/MenuOptions/menuOptionsActions';
import { MealTypes, MenuOrderTypes } from '../../../server/constants';
import _ from 'lodash';
import CustomSubmit from '../../Misc/customSubmit';

var converter = require('number-to-words');
const CheckboxTable = checkboxHOC(ReactTable);
const CheckboxTable1 = checkboxHOC(ReactTable);
//let date = new Date();
let activeMonth = undefined; //sessionStorage.getItem('activeMonth')=='null'?undefined:sessionStorage.getItem('activeMonth')
let date = (moment((activeMonth || moment()), 'YYYYMM') || moment()).toDate();
date.setMonth(date.getMonth() + 1)
let month = ('0' + (date.getMonth())).slice(-2);
let year = date.getFullYear();
let day = ('0' + date.getDate()).slice(-2);
let defaultDate = new Date();
defaultDate.setMonth(defaultDate.getMonth() + 1);

let menuData = {};
let menuDates = [];
let history_Data = {};
//let cancelSelectedData = { selectedRows: undefined, type: 'single', reason: '' }
//let restoreSelectedData = { selectedRows: undefined, type: 'single' }
const modalStyles = {
    content: {
        top: '40%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '30%',
        transform: 'translate(-50%, -50%)',
        overflow: 'initial'
    }
};
const historymodalStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '70%',
        transform: 'translate(-50%, -50%)',
        overflow: 'initial'
    }
};
let gradeList = [];
const modEnum = getModuleEnum();
class ordersGrid extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orderedMenu: [],
            loading: false,
            students: [],
            data: [],
            columns: [],
            historydata: [],
            event: [],
            history_Count: 0,
            //historycolumns: [],
            selection: [],
            selectionIds: [],
            selectAll: false,
            selectType: 'checkbox',
            tabIndex: 0,
            selectedIndex: 0,
            action: 'Ordered',
            filter: 'byStudents',
            date: date,
            replacedItem: '',
            cancelConformModal: false,
            cancelModal: false,
            restoreConformModal: false,
            restoreModal: false,
            restoreDate: new Date(),
            historyModal: false,
            mealType: (getOrderMenuOptions()[0] || ''),

            cancelOrdersCount: 0,
            restoreOrdersCount: 0,
            cancelSelectedData: { selectedRows: undefined, type: 'single', reason: '', cancelDate: undefined, _cancelDate: undefined },
            restoreSelectedData: { selectedRows: undefined, type: 'single', restoreDate: undefined, _restoreDate: undefined }
        };
        this.handleSelect = this.handleSelect.bind(this);
        this.cancelOrderItensSubmit = this.cancelOrderItensSubmit.bind(this);
        this.onCancelConformSubmit = this.onCancelConformSubmit.bind(this);
        this.restoreOrderItensSubmit = this.restoreOrderItensSubmit.bind(this);
    }
    componentWillMount = () => {
        menuDates = Object.keys(menuData);
        let filter = ''
        let grade = ''
        let activeMonth = undefined; //sessionStorage.getItem('activeMonth')=='null'?undefined:sessionStorage.getItem('activeMonth')
        let date = (moment((activeMonth || moment()), 'YYYYMM') || moment()).toDate();
        date.setMonth(date.getMonth())
        try {
            filter = this.context.router.route.match.params.filter || 'Ordered';
            grade = this.context.router.route.match.params.grade || 0;
            let getDate = this.context.router.route.match.params.monthYear;
            if (getDate !== undefined && getDate !== '' && getDate !== null) {
                date = (moment((getDate), 'YYYYMM') || moment()).toDate()
            }
        }
        catch (error) {
            filter = 'Ordered'
            //let date = (moment((sessionStorage.getItem('activeMonth')||moment()),'YYYYMM')||moment()).toDate();
            let date = (moment(moment(), 'YYYYMM') || moment()).toDate();
            date.setMonth(date.getMonth())
        }
        this.setState({ date: date, tabIndex: grade },
            () => {

                this.getReportsData((grade == undefined || grade == "") ? 0 : grade, filter);
            });
        this.props.setMonthYear(date.getFullYear() + '' + ('0' + (date.getMonth() + 1)).slice(-2));
    };
    componentDidMount = () => {

        this._notificationSystem = this.refs.notificationSystem;
    }
    filterSchool = () => {
        let s = document.getElementById('search').value;
        // Changing the search changes the visible rows, so drop any selection made against the previous rows.
        this.setState({ selectAll: false, selection: [], selectionIds: [] });
        //alert(s)
        if (s.length > 0) {
            let searchedSchool = [];
            this.state.students.forEach(obj => {
                /*  if (obj.name != null && (obj.name.toLowerCase()).startsWith(s.toLowerCase())) {
                     searchedSchool.push(obj);
                 } else  */
                if (obj.studentFName != null && (obj.studentFName.toLowerCase()).startsWith(s.toLowerCase())) {
                    searchedSchool.push(obj);
                } else if (obj.studentLName != null && (obj.studentLName.toLowerCase()).startsWith(s.toLowerCase())) {
                    searchedSchool.push(obj);
                } else if (obj.studentId != null && (obj.studentId.toLowerCase()).startsWith(s.toLowerCase())) {
                    searchedSchool.push(obj);
                } else if (obj.pin != null && (obj.pin.toLowerCase()).startsWith(s.toLowerCase())) {
                    searchedSchool.push(obj);
                }
            });
            this.updateState(searchedSchool);
        }
        else {
            //document.getElementById("addSchool").classList.remove("flash-button");
            //this.setState({currentPage: 0})
            this.setState({ students: [] });
            this.getReportsData(this.state.tabIndex, this.state.action);
        }
        this.forceUpdate();

    };
    toggleSelection = (key, shift, row) => {

        let selection = [...this.state.selection];
        let selectionIds = [...this.state.selectionIds];
        let recid = row.studentRecId;
        const keyIndex = selection.indexOf(key);
        const recidIndex = selectionIds.indexOf(recid);
        // check to see if the key exists
        if (keyIndex >= 0) {
            // it does exist so we will remove it using destructing
            selection = [
                ...selection.slice(0, keyIndex),
                ...selection.slice(keyIndex + 1)
            ];
        } else {
            // it does not exist so add it
            selection.push(key);
        }

        // check to see if the key exists
        if (recidIndex >= 0) {
            // it does exist so we will remove it using destructing
            selectionIds = [
                ...selectionIds.slice(0, recidIndex),
                ...selectionIds.slice(recidIndex + 1)
            ];
        } else {
            // it does not exist so add it
            selectionIds.push(recid);
        }
        // update the state
        this.setState({ selectAll: false, selection: selection, selectionIds: selectionIds });
    };
    toggleAll = () => {

        const selectAll = this.state.selectAll ? false : true;
        const selection = [];
        const selectionIds = [];
        if (selectAll) {
            // we need to get at the internals of ReactTable
            let wrappedInstance = {}
            if (this.state.action.toLowerCase() === 'NotOrdered'.toLowerCase()) {
                wrappedInstance = this.checkboxTable1.getWrappedInstance();
            }
            else {
                wrappedInstance = this.checkboxTable.getWrappedInstance();

            }
            // the 'sortedData' property contains the currently accessible records based on the filter and sort
            const currentRecords = wrappedInstance.getResolvedState().sortedData;
            // we just push all the IDs onto the selection array
            currentRecords.forEach(item => {
                selection.push(item.studentId);
                selectionIds.push(item._original.studentRecId)
            });
        }
        this.setState({ selectAll, selection });
        this.setState({ selectionIds, selectionIds });
    };
    isSelected = key => {
        const res = (this.state.selection || []).find((item) => {
            const _item = ((item || '') + '').replace('select-', '');
            return _item == key;
        });
        if (res) {
            return true;
        } else {
            return false;
        }
    };
    logSelection = () => {
        console.log("selection:", this.state.selection);
    };
    selectDate = (e) => {
        date = new Date(e);
        year = date.getFullYear();
        month = ('0' + (date.getMonth() + 1)).slice(-2);
        day = ('0' + date.getDate()).slice(-2);
        try {
            $('[id$="-action"]').show();
            $('[id$="-editForm"]').hide();
        } catch (e) {

        }
        this.setState({ date: new Date(e) }, () => {
            this.state.filter === 'byStudents' ? this.getReportsData(this.state.tabIndex, this.state.action) : this.getItemsData();
        });
        this.props.setMonthYear(year + '' + month);
    }
    recordPayment = (action, rowData) => {
        let loggedUser = sessionStorage.getItem('loggedUserName');
        let headers = {
            'Content-Type': 'application/json'
        };
        let data = [];
        //alert(JSON.stringify(rowData,null,2));
        if (action === 'single') {
            data = [rowData.studentRecId]
        }
        else if (action === 'multiple') {
            /*this.state.selection.length !== 0 ? data = {
                "schoolId": schoolId,
                "studentIds": this.state.selection
            } : _addNotificationError('Please select at least one student',this);*/
        }
        //alert(JSON.stringify(data));
        let yearMonth = (moment(this.state.date, 'YYYY-MM-DD').format().split('-')[0]) + '' + (moment(this.state.date, 'YYYY-MM-DD').format().split('-')[1]);
        console.log('yearMonth', yearMonth);

        postWithHeaders('/orderPayment?loggedUser=' + loggedUser + '&yearMonth=' + yearMonth + '&menuType=' + this.state.mealType + '&access_token=', JSON.stringify(data), headers).then((response) => {
            console.log('response', response);
            if (response.status === 200) {
                this.setState({ loading: false })
                _addNotification('Succesfully updated payment.', this);
                //alert('Succesfully sent notification to parents')
                this.getReportsData(this.state.tabIndex, this.state.action);
            } else if (!response.ok) {
                throw Error(response.statusText);
            }
            //alert(response.status)
        }).catch(
            (error) => {
                this.setState({ loading: false })
                _addNotificationError('Failed to updated payment ! Try again.', this);
                console.log('Send Notification Error', error)
            }
        );
    }
    setTableData = (data) => {
        // alert('Sucess' + JSON.stringify(data, null, 2));
        if (!data) {
            data = [];
            // _addNotificationError('No Orders Available for this Date !', this);
        }
        Array.prototype.sum = function (prop) {
            var total = 0
            for (var i = 0, _len = this.length; i < _len; i++) {
                total += this[i][prop]
            }
            return total
        };

        data.totalOrdersPrice = data.sum('orderPrice');

        console.log('data', data);
        this.getColumns(data).then(col => {
            console.log('columns', col);
            this.setState({
                students: _.orderBy(data, ['orderDateTime'], ['desc']),
                data: _.orderBy(data, ['orderDateTime'], ['desc']),
                columns: col,
                loading: false
            })
        });
    }
    sendItemChangeNotification = (e, item) => {
        e.preventDefault()
        this.setState({ loading: true });
        let yearMonth = (moment(this.state.date, 'YYYY-MM-DD').format().split('-')[0]) + '' + (moment(this.state.date, 'YYYY-MM-DD').format().split('-')[1]);
        console.log('yearMonth', yearMonth);
        let body = {
            "mealSchoolId": sessionStorage.getItem('SchoolId'),
            "itemId": item.itemId,
            "yearMonth": yearMonth,
            "customMessage": document.getElementById(item.itemId + "-message").value
        }
        // alert(body.customMessage)
        let headers = {
            'Content-Type': 'application/json'
        };
        postWithHeaders('/reports/mealChangeNotification?access_token=', JSON.stringify(body), headers).then((response) => {

            console.log('get response', response);
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            this.setState({ loading: false, replacedItem: '' });
            this.cancelItemChange(item.itemId)
            _addNotification('Successfully sent notification to parents.', this)
        }).catch(
            (error) => {
                this.setState({ loading: false, replacedItem: '' });
                _addNotificationError('Action failed. Please try again later.', this)
                console.log('Get Menu data response', error)

            }
        );

    }
    getItemsData = () => {
        let yearMonth = (moment(this.state.date, 'YYYY-MM-DD').format().split('-')[0]) + '' + (moment(this.state.date, 'YYYY-MM-DD').format().split('-')[1]);
        console.log('yearMonth', yearMonth);
        let schoolId = sessionStorage.getItem('SchoolId');
        get('/reports/monthlyMenuDetails?mealSchoolId=' + schoolId + '&orderDate=' + moment(this.state.date).format('YYYY-MM-DD') + '&menuType=' + this.state.mealType + '&access_token=').then((response) => {
            //  get('/reports/monthlyMenuDetails?mealSchoolId=' + schoolId + '&yearMonth=' + yearMonth + '&access_token=').then((response) => {
            this.setState({ loading: true });
            console.log('get response', response);
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            console.log('data', data);
            menuData = data || {};
            console.log('menuData', menuData);
            menuDates = Object.keys(menuData);
            let day = ('0' + this.state.date.getDate()).slice(-2);
            let mm = (moment(this.state.date, 'YYYY-MM-DD').format().split('-')[1]);
            console.log('mm/dd', mm + '/' + day);
            this.setTableData(menuData[mm + '/' + day]);
            //this.state.tabIndex = mm + '/' + day;
            this.state.tabIndex = 0;
            this.setState({ loading: false });
        }).catch(
            (error) => {
                this.setTableData(undefined);
                this.setState({ loading: false });
                _addNotificationError('Action failed. Please try again later.', this)
                console.log('Get Menu data response', error)

            }
        );
    };
    getRestore_OrdersCount = (callback) => {
        let row = this.state.restoreSelectedData.selectedRows;
        let type = this.state.restoreSelectedData.type;
        let selectedRows = [];
        let data = { restoreNote: '', gradeList: [], dateList: [] };
        let schoolId = sessionStorage.getItem('SchoolId');
        let yearMonth = (moment(this.state.date, 'YYYY-MM-DD').format().split('-')[0]) + '' + (moment(this.state.date, 'YYYY-MM-DD').format().split('-')[1]);
        console.log('yearMonth', yearMonth);
        if (type === 'single') {
            selectedRows = [row.studentRecId];
            data = {
                restoreDate: this.state.restoreSelectedData.restoreDate ? this.state.restoreSelectedData.restoreDate : undefined,
                "restoreNote": this.state.restoreSelectedData.reason,
                "yearMonth": yearMonth,
                "studentRecordIds": selectedRows//selectedRows               
            }
        }
        else if (type === 'multiple') {
            //selectedRows = this.state.selection;

            // Always send the explicitly selected students (see cancel flow).
            selectedRows = this.state.selectionIds;
            if (selectedRows.length !== 0) {
                data = {
                    restoreDate: this.state.restoreSelectedData.restoreDate ? this.state.restoreSelectedData.restoreDate : undefined,
                    "restoreNote": this.state.restoreSelectedData.reason,
                    "yearMonth": yearMonth,
                    "studentRecordIds": selectedRows
                }
            } else {
                _addNotificationError('Please select at least one student.', this);
                return false;
            }
        }
        let headers = {
            'Content-Type': 'application/json'
        };
        if (data.restoreDate === undefined) {
            _addNotificationError("Select date for restore cancelled order item.", this);
            return false;
        }
        if (data.restoreNote.trim().length <= 0) {
            _addNotificationError("Reason for restore cancelled order item is required.", this);
            return false;
        }

        this.setState({ loading: true });
        postWithHeadersResponse(URL_VERSION3 + '/eligibleRestoreOrders/' + sessionStorage.getItem('SchoolId') + '/' + this.state.mealType + '?access_token=', JSON.stringify(data), headers).then((response) => {
            if (response.ok) {
                return response;
            }
            if (response.statusCode !== 200) {
                if (response.statusCode == 400) {
                    _addNotificationError(response.statusMessage, this);
                    throw Error(response.statusMessage);
                }
                throw Error(response.statusMessage);
            }
            return response;
        }).then(res => {
            this.setState({ loading: false, restoreOrdersCount: res.resp, restoreConformModal: true });
            callback(true);
        }).catch(
            (error) => {
                this.setState({ loading: false });
                _addNotificationError(error.message, this);
                callback(true);
            }
        );
    }

    getCancel_OrdersCount = (callback) => {
        let row = this.state.cancelSelectedData.selectedRows;
        let type = this.state.cancelSelectedData.type;

        let selectedRows = [];
        //let data = { cancellationNote: '', gradeList: [], dateList: [] };
        let data = {};
        let schoolId = sessionStorage.getItem('SchoolId');
        let yearMonth = (moment(this.state.date, 'YYYY-MM-DD').format().split('-')[0]) + '' + (moment(this.state.date, 'YYYY-MM-DD').format().split('-')[1]);
        console.log('yearMonth', yearMonth);
        if (type === 'single') {
            selectedRows = [row.studentRecId];
            data = {
                gradeList: [],
                dateList: this.state.cancelSelectedData.cancelDate ? [this.state.cancelSelectedData.cancelDate] : [],
                "cancellationNote": this.state.cancelSelectedData.reason,
                "yearMonth": yearMonth,
                'isGradeWise': false,
                "studentRecordIds": selectedRows,//selectedRows
                "schoolId": schoolId,
                "loggedUser": sessionStorage.getItem('loggedUserName')
            }
        }
        else if (type === 'multiple') {
            //selectedRows = this.state.selection;
            // Always send the explicitly selected students. Select-all only selects the
            // visible (possibly search-filtered) rows, so never fall back to a grade-wise cancel.
            selectedRows = this.state.selectionIds;
            if (selectedRows.length !== 0) {
                data = {
                    gradeList: [],
                    dateList: this.state.cancelSelectedData.cancelDate ? [this.state.cancelSelectedData.cancelDate] : [],
                    "cancellationNote": this.state.cancelSelectedData.reason,
                    "yearMonth": yearMonth,
                    'isGradeWise': false,
                    "studentRecordIds": selectedRows,//selectedRows
                    "schoolId": schoolId,
                    "loggedUser": sessionStorage.getItem('loggedUserName')
                }
            } else {
                _addNotificationError('Please select at least one student.', this);
                return false;
            }
        }
        let headers = {
            'Content-Type': 'application/json'
        };
        if (data.dateList.length <= 0) {
            _addNotificationError("Select date for cancel order.", this);
            callback(true);
            return false;
        }
        if (data.cancellationNote.trim().length <= 0) {
            _addNotificationError("Reason for cancellation is required.", this);
            callback(true);
            return false;
        }
        this.setState({ loading: true });
        postWithHeadersResponse(URL_VERSION3 + '/eligibleCancelOrders/' + sessionStorage.getItem('SchoolId') + '/' + this.state.mealType + '?access_token=', JSON.stringify(data), headers)
            .then((response) => {
                if (response.ok) {
                    return response;
                }
                if (response.statusCode !== 200) {
                    if (response.statusCode == 400) {
                        _addNotificationError(response.statusMessage, this);
                        throw Error(response.statusMessage);
                    }
                    throw Error(response.statusMessage);
                }
                console.log('response', response);
                return response;
            }).then(res => {
                this.setState({ cancelOrdersCount: res.resp, loading: false, cancelModal: false, cancelConformModal: true });
                callback(true);
            }).catch(
                (error) => {
                    this.setState({ loading: false })
                    callback(true);
                    // this.setState({ cancelModal: false})            
                }
            )
    };

    cancelItemChange = (id) => {
        $("#" + id + "-action").show();
        $("#" + id + "-editForm").hide();
        this.setState({ replacedItem: '' })
    }
    editMessageFun = (item, e) => {
        this.state.replacedItem = e.target.value;
        console.log(e.target.value)
        console.log(this.state.replacedItem)
        $("#" + item.itemId + "-action").hide();
        $("#" + item.itemId + "-editForm").show();
        $("#" + item.itemId + "-message").val("Your ordered meal item: '" + item.itemName + "' for the date '" + ("0" + (this.state.date.getMonth() + 1)).slice(-2) + "/" + ("0" + this.state.date.getDate()).slice(-2) + "/" + (this.state.date.getFullYear()) + " has been replaced with '" + (!e.target.value ? "Replaced_Item" : e.target.value) + "' due to unavailability. Sorry for the inconvenience.");
        this.forceUpdate();
    }

    renderInput = (props, openCalendar, closeCalendar) => {
        function clear() {
            props.onChange({ target: { value: '' } });
        }

        return (
            <div>
                <input {...props} />
                <button className="input-group-addon" onClick={openCalendar}>
                    <i className="fa fa-calendar"></i>
                </button>
            </div>
        );
    }
    CancelBtn = (type, row) => (
        <div className="col-xs-7">
            <button
                className="btn btn-warning button-xs pull-right bg-color-3"
                onClick={() => {
                    const cancelSelectedData = this.state.cancelSelectedData;
                    cancelSelectedData.selectedRows = row;
                    cancelSelectedData.type = type;
                    cancelSelectedData.cancelDate = '';
                    cancelSelectedData._cancelDate = undefined;
                    cancelSelectedData.reason = '';
                    if (this.state.selectionIds.length <= 0) {
                        _addNotificationError('Please select at least one student.', this);
                        return false;
                    }
                    console.log('selected rows :', this.state.selectionIds);
                    this.setState({ cancelModal: true, cancelSelectedData: cancelSelectedData })
                }
                }
                style={{
                    float: 'right',
                    margin: '5px 0px'
                }}>
                <i className="fa fa-minus-circle"></i> Cancel Order Menu
            </button>
        </div>
    );
    RestoreBtn = (type, row) => (
        <div className="col-xs-5">
            <button
                className="btn btn-warning button-xs pull-right bg-color-4"
                onClick={() => {
                    const restoreSelectedData = this.state.restoreSelectedData
                    restoreSelectedData.selectedRows = row;
                    restoreSelectedData.type = type;
                    restoreSelectedData.reason = '';
                    restoreSelectedData.restoreDate = '';
                    restoreSelectedData._restoreDate = undefined;

                    if (this.state.selectionIds.length <= 0) {
                        _addNotificationError('Please select at least one student.', this);
                        return false;
                    }
                    this.setState({ restoreModal: true, restoreSelectedData: restoreSelectedData })
                }
                }
                style={{
                    float: 'right',
                    margin: '5px 0px'
                }}>
                <i class="fa fa-repeat" aria-hidden="true"></i> Restore Order Menu
            </button>
        </div>
    );

    getReportsData(gradeName, action) {
        gradeName = ((gradeName || 0) == 0 ? 0 : gradeName);

        //console.log('grades',grades);
        //alert(gradeName);
        this.setState({ loading: true, action: action });
        let schoolId = sessionStorage.getItem('SchoolId');
        let url1 = '';
        let url2 = '';
        let yearMonth = (moment(this.state.date, 'YYYY-MM-DD').format().split('-')[0]) + '' + (moment(this.state.date, 'YYYY-MM-DD').format().split('-')[1]);
        console.log('yearMonth', yearMonth);
        let schoolYear = sessionStorage.getItem('schoolYearValue');
        //const mType=(this.state.mealType===MealTypes.LUNCH) &&!isRegularLunchOrderType()?MenuOrderTypes.ITEMIZE:this.state.mealType;

        switch (action) {
            case 'Ordered':
                url1 = '/reports/orderSummaryReport?mealSchoolId=' + schoolId + '&yearMonths=' + yearMonth + '&menuType=' + this.state.mealType + '&schoolYear=' + schoolYear + '&access_token=';
                url2 = '/reports/orderSummaryReport?mealSchoolId=' + schoolId + '&yearMonths=' + yearMonth + '&menuType=' + this.state.mealType + '&grades=' + gradeName + '&schoolYear=' + schoolYear + '&access_token=';
                break;
            case 'Paid':
                url1 = '/reports/orderSummaryReport?mealSchoolId=' + schoolId + '&yearMonths=' + yearMonth + '&menuType=' + this.state.mealType + '&paymentStatus=true&access_token=';
                url2 = '/reports/orderSummaryReport?mealSchoolId=' + schoolId + '&yearMonths=' + yearMonth + '&menuType=' + this.state.mealType + '&grades=' + gradeName + '&schoolYear=' + schoolYear + '&paymentStatus=true&access_token=';
                break;
            case 'NotPaid':
                url1 = '/reports/orderSummaryReport?mealSchoolId=' + schoolId + '&yearMonths=' + yearMonth + '&menuType=' + this.state.mealType + '&paymentStatus=false&access_token=';
                url2 = '/reports/orderSummaryReport?mealSchoolId=' + schoolId + '&yearMonths=' + yearMonth + '&menuType=' + this.state.mealType + '&grades=' + gradeName + '&schoolYear=' + schoolYear + '&paymentStatus=false&access_token=';
                break;
        }
        if (action === 'NotOrdered') {
            (gradeName == 0 ? (get('/reports/notOrderedStudents?isVersion2=true&mealSchoolId=' + schoolId + '&menuType=' + this.state.mealType + '&yearMonth=' + yearMonth + '&schoolYear=' + sessionStorage.getItem('schoolYearValue') + '&access_token=')) : (get('/reports/notOrderedStudents?isVersion2=true&mealSchoolId=' + schoolId + '&yearMonth=' + yearMonth + '&grades=' + gradeName + '&menuType=' + this.state.mealType + '&schoolYear=' + sessionStorage.getItem('schoolYearValue') + '&access_token='))).then((response) => {
                console.log('get response', response);
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response.json();
            }).then(data => {
                let studentData = data || [];

                studentData.map(student => {
                    student._id = student.studentId;
                    student.name = student.studentLName + ', ' + student.studentFName;
                });
                this.setTableData(studentData);
            }).catch(
                (error) => {
                    this.setState({ loading: false })
                    console.log('Get School data response', error)

                }
            );
        }
        else {
            (gradeName == 0 ? (get(url1)) : (get(url2))).then((response) => {
                // console.log('get response', response);
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response.json();
            }).then(data => {
                let studentData = data || [];
                studentData.map(student => {
                    student._id = student.studentId;
                    student.name = student.studentLName + ', ' + student.studentFName;
                    student.payment = student.paymentStatus ? 'Paid' : 'Not Paid';
                });
                this.setTableData(studentData);
            }).catch(
                (error) => {
                    this.setState({ loading: false });
                }
            );
        }
    }
    getColumns(data) {

        console.log('data for get cols', data);
        let columns = [];
        return new Promise((resolve) => {
            if (this.state.filter === 'byStudents') {
                let header = ['NAME', 'ORDER', 'PRICE', 'PAYMENT STATUS'];
                if (data.length === 0) {
                    {
                        header.map(key =>
                            columns.push({ Header: key }));
                    }
                }
                else {
                    columns.push({
                        accessor: 'name',
                        id: 'name',
                        Header: 'STUDENT NAME',
                        style: { textAlign: 'center' },
                        sortable: true,
                        defaultSortDesc: true
                    });
                    columns.push({
                        accessor: 'studentId',
                        Header: 'STUDENT ID',
                        style: { textAlign: 'center' }
                    });
                    columns.push({
                        accessor: 'pin',
                        Header: 'Pin',
                        style: { textAlign: 'center' }
                    });

                    if (this.state.action !== 'NotOrdered') {
                        columns.push({
                            id: 'orderDateTime',
                            Header: 'ORDER DATE',
                            //Cell: props => <span>{new Date(props.original.orderDateTime).toLocaleString() }</span> ,
                            Cell: props => <span>{moment(props.original.orderDateTime).format(date_format() + ' , ' + 'hh:mm:ss a')}</span>,
                            style: { textAlign: 'center' },
                            width: 200,
                            sortable: true,
                            defaultSortDesc: true
                        })
                    };

                    if (this.state.action !== 'NotOrdered') {
                        columns.push({
                            accessor: 'orderPrice',
                            Header: 'ORDER PRICE',
                            width: 150,
                            style: { textAlign: 'center' },
                            Cell: ({ row }) => (
                                <span style={{ textAlign: 'right' }}>
                                    {currency_symbol() + ' ' + convertTwoDecimalPoint(row._original.orderPrice)} </span>),
                            Footer: () => (
                                <span style={{ textAlign: 'right' }}>
                                    {/* Total Amount: $ {this.state.data.totalOrdersPrice ? this.state.data.totalOrdersPrice: '0.00'} */}
                                    Total Amount: {currency_symbol() + '' + convertTwoDecimalPoint(_.sumBy(this.state.data, (o) => { return (o.orderPrice || 0.00); }))}
                                </span>
                            )
                        });
                        columns.push({
                            accessor: 'totItems',
                            Header: 'NO OF MEALS',
                            style: { textAlign: 'center' },
                        });
                        if (this.state.action !== 'NotPaid') {
                            columns.push({
                                accessor: 'payment',
                                Header: 'PAYMENT STATUS',
                                style: { textAlign: 'center' }
                            });
                        }
                    }
                    columns.push({
                        id: 'actionButton',
                        accessor: "studentId",
                        Header: 'ACTIONS',
                        style: { textAlign: 'center' }, // className: "actions text-center"
                        Cell: ({ row }) => (
                            row._original.orderDate == undefined ? (
                                <div>
                                    <a title="Send reminder to parent"
                                        onClick={() => this.sendNotification('single', row._original)}><i
                                            className="fa fa-paper-plane-o tbl-rounded-icon btn-warning fa-icon" /></a>
                                    <Link title="click to order meal" className="color-1" to={'/schoolAdmin/menu/' + row._original.studentRecId + '/' + this.state.mealType + '/new'} >
                                        <i className="fa fa-cutlery tbl-rounded-icon bg-color-2 fa-icon" /></Link>
                                </div>

                            ) : (
                                row.payment === 'Not Paid' || row.payment == undefined ?
                                    (<div>
                                        <Link title="click to update order meal" className="color-1" to={'/schoolAdmin/menu/' + row._original.studentRecId + '/' + this.state.mealType + '/update'} >
                                            <i className="fa fa-cutlery tbl-rounded-icon bg-color-2 fa-icon" /></Link>
                                        {
                                            < a title="click to cancel ordered menu for selected date " className="color-1" onClick={() => {
                                                const cancelSelectedData = this.state.cancelSelectedData;
                                                cancelSelectedData.selectedRows = row._original;
                                                cancelSelectedData.type = 'single'
                                                this.setState({ cancelModal: true })
                                            }}  >
                                                <i className="fa fa-minus-circle  tbl-rounded-icon bg-color-3 fa-icon" /></a>
                                        }
                                        {(this.state.tabIndex === undefined ? 0 : this.state.tabIndex) != 0 ?

                                            < a title="click to restore ordered menu for selected date " className="color-1" onClick={() => {
                                                const restoreSelectedData = this.state.restoreSelectedData;
                                                restoreSelectedData.selectedRows = row._original;
                                                restoreSelectedData.type = 'single'
                                                this.setState({ restoreModal: true, restoreSelectedData: restoreSelectedData })
                                            }}  >
                                                <i class="fa fa-repeat tbl-rounded-icon bg-color-4 fa-icon" aria-hidden="true"></i>
                                            </a>
                                            : null}
                                        {
                                            < a title="click to see the order history" className="color-1" onClick={() => this.getHistory(row._original.orderId)}>
                                                <i className="fa fa-history  tbl-rounded-icon bg-color-6 fa-icon" /></a>
                                        }
                                    </div>)
                                    :
                                    row.payment === 'Paid' ?
                                        <Fragment><Link title="click to update order meal" className="color-1" to={'/schoolAdmin/menu/' + row._original.studentRecId + '/' + this.state.mealType + '/update'} >
                                            <i className="fa fa-cutlery tbl-rounded-icon bg-color-2 fa-icon" /></Link>
                                            < a title="click to see the order history" className="color-1" onClick={() => this.getHistory(row._original.orderId)}>
                                                <i className="fa fa-history  tbl-rounded-icon bg-color-6 fa-icon" /></a></Fragment>
                                        : null

                            )
                        ),
                    });

                    // }

                }
            }
            else {
                let header = ['ITEM NAME', 'ORDER COUNT', 'ACTION'];
                if (data.length === 0) {
                    {
                        header.map(key =>
                            columns.push({ Header: key }));
                    }
                }
                else {
                    columns.push({
                        accessor: 'itemName',
                        Header: 'ITEM NAME',
                        style: { textAlign: 'center' },
                        width: 400
                    });
                    columns.push({
                        accessor: 'count',
                        Header: 'ORDER COUNT',
                        style: { textAlign: 'center' },
                        width: 150
                    });
                    /* columns.push({
                        accessor: 'grades',
                        Header: 'GRADES',
                        style: {textAlign: 'center'},
                        width: 200
                    }); */
                    columns.push({
                        id: 'actionButton',
                        accessor: "itemId",
                        Header: 'ACTION',
                        style: { textAlign: 'center' }, // className: "actions text-center"
                        Cell: ({ row }) => (

                            <div>
                                <div className="form-group clearfix" id={row._original.itemId + "-action"}>
                                    <div>
                                        <a title="Send item change message to parent" href="javascript:void(0);"
                                            onClick={(e) => this.editMessageFun(row._original, e)}>Notify Item
                                            Change<i
                                                className="fa fa-envelope tbl-rounded-icon bg-color-4 fa-icon " /></a>
                                    </div>
                                </div>
                                <div className="form-group clearfix user-form-fieldset"
                                    id={row._original.itemId + "-editForm"}
                                    style={{ display: 'none' }}>
                                    <fieldset className="user-fieldset">
                                        <form onSubmit={(e) => this.sendItemChangeNotification(e, row._original)}>
                                            <legend>Item Change Notification</legend>
                                            <div className="form-group clearfix">
                                                <label className="pull-left control-label">Replaced
                                                    Item: </label>
                                                <input type="text" className="form-control"
                                                    placeholder={`Replaced Item Name`}
                                                    value={this.state.replacedItem} style={{ marginRight: '20px' }}
                                                    onChange={e => this.editMessageFun(row._original, e)} required />
                                                <label className="pull-left control-label">Message: </label>
                                            </div>
                                            <div>
                                                <textarea className="form-control" rows="5"
                                                    defaultValue={"Your ordered meal item <Original_Item> for <Day Date> has been replaced with <Replaced_Item> due to unavailability. Sorry for the inconvenience."}
                                                    id={row._original.itemId + "-message"} />
                                            </div>

                                            <div className="form-group clearfix">
                                                <label className="col-md-4 control-label"></label>
                                                <div className="col-md-12">
                                                    <input type="button" className="pull-left btn btn-danger"
                                                        id="changeUpdate" value='Cancel'
                                                        onClick={() => this.cancelItemChange(row._original.itemId)}>
                                                    </input>
                                                    <input type="submit" className="pull-left btn btn-success"
                                                        value="Send" />
                                                </div>
                                            </div>
                                        </form>
                                    </fieldset>
                                </div>
                            </div>),
                    });
                }
            }
            resolve(columns);
        })
    }

    updateState(newState) {
        /*if (newState.length === 0) {
            document.getElementById("addSchool").classList.add("flash-button");
        } else {
            document.getElementById("addSchool").classList.remove("flash-button");
        }*/
        this.setState({ data: newState });
    }
    restoreOrderItensSubmit(showConform, callback) {
        let row = this.state.restoreSelectedData.selectedRows;
        let type = this.state.restoreSelectedData.type;
        let selectedRows = [];
        let data = { restoreNote: '', gradeList: [], dateList: [] };
        let schoolId = sessionStorage.getItem('SchoolId');
        let yearMonth = (moment(this.state.date, 'YYYY-MM-DD').format().split('-')[0]) + '' + (moment(this.state.date, 'YYYY-MM-DD').format().split('-')[1]);
        console.log('yearMonth', yearMonth);
        if (type === 'single') {
            selectedRows = [row.studentRecId];
            data = {
                restoreDate: this.state.restoreSelectedData.restoreDate ? this.state.restoreSelectedData.restoreDate : undefined,
                "restoreNote": this.state.restoreSelectedData.reason,
                "yearMonth": yearMonth,
                "studentRecordIds": selectedRows//selectedRows               
            }
        }
        else if (type === 'multiple') {
            //selectedRows = this.state.selection;

            // Always send the explicitly selected students (see cancel flow).
            selectedRows = this.state.selectionIds;
            if (selectedRows.length !== 0) {
                data = {
                    restoreDate: this.state.restoreSelectedData.restoreDate ? this.state.restoreSelectedData.restoreDate : undefined,
                    "restoreNote": this.state.restoreSelectedData.reason,
                    "yearMonth": yearMonth,
                    "studentRecordIds": selectedRows
                }
            } else {
                _addNotificationError('Please select at least one student.', this);
                return false;
            }
        }
        let headers = {
            'Content-Type': 'application/json'
        };
        if (data.restoreDate === undefined) {
            _addNotificationError("Select date for restore cancelled order item.", this);
            return false;
        }
        if (data.restoreNote.trim().length <= 0) {
            _addNotificationError("Reason for restore cancelled order item is required.", this);
            return false;
        }
        if (showConform) {
            this.setState({ restoreConformModal: true });
            callback(true);
        }
        else {
            this.setState({ loading: true })
            postWithHeadersResponse(URL_VERSION3 + '/restoreCancelledMenu/' + sessionStorage.getItem('SchoolId') + '/' + this.state.mealType + '?access_token=', JSON.stringify(data), headers).then((response) => {
                if (response.statusCode !== 200) {
                    throw Error(response.statusMessage);
                }
                console.log('response', response);
                return response;
            }).then(res => {
                _addNotification(res.statusMessage, this);
                this.setState({ restoreModal: false, loading: false, restoreConformModal: false });
                callback(true);
                this.getReportsData(this.state.tabIndex, this.state.action);
            }).catch(
                (error) => {
                    this.setState({ loading: false, restoreConformModal: false })
                    _addNotificationError(error.message, this);
                    callback(true);
                    // this.setState({ cancelModal: false})            
                }
            )
        }
    }
    cancelOrderItensSubmit(showConform, callback) {
        let row = this.state.cancelSelectedData.selectedRows;
        let type = this.state.cancelSelectedData.type;

        let selectedRows = [];
        let data = { cancellationNote: '', gradeList: [], dateList: [] };
        let schoolId = sessionStorage.getItem('SchoolId');
        let yearMonth = (moment(this.state.date, 'YYYY-MM-DD').format().split('-')[0]) + '' + (moment(this.state.date, 'YYYY-MM-DD').format().split('-')[1]);
        console.log('yearMonth', yearMonth);
        if (type === 'single') {
            selectedRows = [row.studentRecId];
            data = {
                gradeList: [],
                dateList: this.state.cancelSelectedData.cancelDate ? [this.state.cancelSelectedData.cancelDate] : [],
                "cancellationNote": this.state.cancelSelectedData.reason,
                "yearMonth": yearMonth,
                'isGradeWise': false,
                "studentRecordIds": selectedRows,//selectedRows
                "schoolId": schoolId,
                "loggedUser": sessionStorage.getItem('loggedUserName')
            }
        }
        else if (type === 'multiple') {
            //selectedRows = this.state.selection;
            // Always send the explicitly selected students. Select-all only selects the
            // visible (possibly search-filtered) rows, so never fall back to a grade-wise cancel.
            selectedRows = this.state.selectionIds;
            if (selectedRows.length !== 0) {
                data = {
                    gradeList: [],
                    dateList: this.state.cancelSelectedData.cancelDate ? [this.state.cancelSelectedData.cancelDate] : [],
                    "cancellationNote": this.state.cancelSelectedData.reason,
                    "yearMonth": yearMonth,
                    'isGradeWise': false,
                    "studentRecordIds": selectedRows,//selectedRows
                    "schoolId": schoolId,
                    "loggedUser": sessionStorage.getItem('loggedUserName')
                }
            } else {
                _addNotificationError('Please select at least one student.', this);
                return false;
            }
        }
        let headers = {
            'Content-Type': 'application/json'
        };
        if (data.dateList.length <= 0) {
            _addNotificationError("Select date for cancel order.", this);
            callback(true);
            return false;
        }
        if (data.cancellationNote.trim().length <= 0) {
            _addNotificationError("Reason for cancellation is required.", this);
            callback(true);
            return false;
        }
        if (showConform) {
            this.setState({ cancelConformModal: true });
            callback(true);
        } else {
            this.setState({ loading: true })
            postWithHeadersResponse(URL_VERSION3 + '/menuOrderCancel/' + sessionStorage.getItem('SchoolId') + '/' + this.state.mealType + '?access_token=', JSON.stringify(data), headers).then((response) => {
                if (response.statusCode !== 200) {
                    throw Error(response.statusMessage);
                }
                console.log('response', response);
                return response;
            }).then(res => {
                this.setState({ loading: false, cancelConformModal: false, cancelModal: false })
                _addNotification(res.statusMessage, this);
                callback(true);
                this.getReportsData(this.state.tabIndex, this.state.action);
            }).catch(
                (error) => {
                    this.setState({ loading: false, cancelConformModal: false })
                    _addNotificationError(error.message, this);
                    callback(true);
                    // this.setState({ cancelModal: false})            
                }
            )
        }

    }
    onCancelConformSubmit = () => {

    }

    sendNotification(type, row) {
        this.setState({ loading: true })
        let selectedRows = [];
        let data = {};
        let schoolId = sessionStorage.getItem('SchoolId');
        let yearMonth = (moment(this.state.date, 'YYYY-MM-DD').format().split('-')[0]) + '' + (moment(this.state.date, 'YYYY-MM-DD').format().split('-')[1]);
        console.log('yearMonth', yearMonth);
        //console.log('action',action);
        // console.log('send to', row);
        // console.log('selection', this.state.selection);
        // console.log('selectedRows', selectedRows);
        //alert(type)

        if (type === 'single') {
            selectedRows = [row.studentId];
            data = {
                "schoolId": schoolId,
                "notificationType": this.state.action === "NotOrdered" ? "MealOrderStatus" : "PaymentStatus",
                "studentIds": selectedRows,
                "schoolYear": sessionStorage.getItem('schoolYearValue'),
                "yearMonth": yearMonth
            }
        }
        else if (type === 'multiple') {
            //selectedRows = this.state.selection;
            // Always send the explicitly selected students (see cancel flow).
            {
                selectedRows = this.state.selection;
                selectedRows.length !== 0 ? data = {
                    "schoolId": schoolId,
                    "notificationType": this.state.action === "NotOrdered" ? "MealOrderStatus" : "PaymentStatus",
                    "studentIds": selectedRows,
                    "schoolYear": sessionStorage.getItem('schoolYearValue'),
                    "yearMonth": yearMonth
                } : _addNotificationError('Please select at least one student.', this);
            }
        }
        /*if (action === 'resend') {
            selectedRows = this.state.selection;
            data = {
                "schoolId": schoolId,
                "notificationType": "Registration",
                "studentIds": selectedRows,
                "sendStatus": "true"
            }
        }*/
        let headers = {
            'Content-Type': 'application/json'
        };
        postWithHeaders('/sendNotificationParents?menuType=' + this.state.mealType + '&access_token=', JSON.stringify(data), headers).then((response) => {
            if (response.status === 200) {
                this.setState({ loading: false })
                _addNotification('Succesfully sent reminder to parents.', this);
            } else if (!response.ok) {
                throw Error(response.statusText);
            }
        }).catch(
            (error) => {
                this.setState({ loading: false })
                _addNotificationError('Failed to send reminder ! Try again.', this);
                console.log('Send Notification Error', error)
            }
        );

    }

    handleSelect(selectedIndex) {
        //alert(selectedIndex)
        this.setState({ selectedIndex: selectedIndex });
    }
    getHistory(orderId) {
        let hisdata = [];
        get('/menuOrderHistoryAudits/search/findByOrderId?orderId=' + orderId + '&menuType=' + this.state.mealType + '&access_token=').then((response) => {
            this.setState({ loading: true });
            console.log('get response', response);
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            console.log('data', data);
            let history_Data = data._embedded.menuOrderHistoryAudits || {};
            //this.setState({historydata:history_Data});
            history_Data.map(history_data => {
                let dataHistory = {
                    createdOn: standardDateFormat(history_data.createdOn).toLocaleDateString() + ' ' + standardDateFormat(history_data.createdOn).toLocaleTimeString(),
                    createdBy: history_data.createdBy,
                    items_count: history_data.items_count,
                    orderAmount: history_data.orderAmount,
                    salesTaxAmt: history_data.salesTaxAmt,
                    crudOperationVal: history_data.crudOperationVal,
                    cancellationNote: history_data.cancellationNote || ''
                }
                hisdata.push(dataHistory);
            });
            this.setState({ historydata: hisdata, history_Count: hisdata.length, loading: false });
        }).catch(
            (error) => {
                this.setState({ loading: false });
                console.log('Menu order history audits response', error);
            }
        );
        this.setState({ historyModal: true });
    }
    closeHistory() {
        this.setState({ historydata: [], historyModal: false });
    }
    getTabIndex = (gradeList = []) => {
        const idx = gradeList.findIndex(item => item.value === this.state.tabIndex);
        return (idx < 0 ? 0 : idx)
    }

    render() {
        gradeList = getSchoolGrades();
        const { toggleSelection, toggleAll, isSelected, logSelection } = this;
        const { data, columns, selectAll } = this.state;
        const _tabIndex = this.getTabIndex(gradeList);
        console.log("selection:", this.state.selection);


        const checkboxProps = {
            selectAll,
            isSelected,
            toggleSelection,
            toggleAll,
            selectType: "checkbox",

            getTheadProps: () => {
                return {
                    style: {
                        backgroundColor: "#D2D7D4", fontWeight: 'bold'
                    },
                    className: "bg-success base-reverse"
                };
            },
            getTableProps: () => {
                return {
                    className: "table table-hover"
                }
            },

        };

        {
            $('#selector button').click(function () {
                $(this).addClass('active').siblings().removeClass('active');
            })
        }

        {
            $('#filterBy button').click(function () {
                $(this).addClass('active').siblings().removeClass('active');
            })
        }
        {
            $("#changeUpdate button").click(function () {
                $("#changeMessageOne").show();
                $("#changeMessageTwo").hide();
            });
        }
        console.log(this.state.tabIndex);
        try {
            $("#selector>button.active").removeClass("active");
            document.getElementById(this.state.action).classList.add("active")
        } catch (error) {
        }
        console.log('action', this.state.action);

        return (
            <div>

                <NotificationSystem ref="notificationSystem" />
                <section className=" full-width clearfix">
                    <div className='sweet-loading'
                        style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000' }}>
                        <BeatLoader
                            size={20}
                            color={'#ea7066'}
                            loading={this.state.loading}
                        />
                    </div>

                    <div className="container">
                        <div className="row">
                            <div className=" pull-left sectionTitle">
                                <h2 style={{ margin: '20px 0px 0px' }}>
                                    <span style={{ margin: '10px 10px 0px 0px' }}>Manage Orders for:</span>
                                </h2>
                            </div>
                            <div className=" form-group uploadFileInfo col-md-3">
                                <div className="input-group" style={{ margin: '20px 0px 0px' }}>
                                    <Datetime
                                        dateFormat={this.state.filter === 'byStudents' ? "MMMM YYYY" : date_format()}
                                        timeFormat={false} closeOnSelect="true"
                                        viewMode={this.state.filter === 'byStudents' ? "months" : "days"}
                                        defaultValue={this.state.date} onChange={this.selectDate}
                                        renderInput={this.renderInput} />


                                </div>
                            </div>
                            <div id="filterBy" className="btn-group text-center"
                                style={{ margin: '7px 0px 0px', display: 'block' }}>
                                <button type="button" className="btn btn-xs btn-inactive-color active"
                                    id="byStudents"
                                    style={{}}
                                    onClick={() => {
                                        this.getReportsData(0, 'Ordered');
                                        this.setState({ filter: 'byStudents' })
                                    }}>By Students
                                </button>

                                <button type="button" className="btn btn-xs btn-inactive-color"
                                    style={{}} id="byItems"
                                    onClick={() => {
                                        console.log('state date is :', this.state.date)
                                        this.setState({
                                            filter: 'byItems',
                                            date: this.state.date
                                        }, () => {
                                            console.log('state date is :', this.state.date)
                                            this.getItemsData();
                                        })
                                    }}>By Items
                                </button>
                                <div className="pull-right" style={{ display: 'inline-block', marginLeft: '50px', marginTop: '16px' }}>
                                    <MenuOptions id={'menuOptions'} menuOptionsList={getOrderMenuOptions()} onOptionSelect={(type) => {
                                        this.setState({ mealType: type }, () => {
                                            // this.getReportsData(this.state.tabIndex, this.state.action)
                                            if (this.state.filter === 'byStudents') {
                                                this.getReportsData(this.state.tabIndex, this.state.action)
                                            } else if (this.state.filter === 'byItems') {
                                                this.getItemsData();
                                            }
                                        })
                                    }} selectedOption={(this.state.mealType)} />
                                </div>
                                <a title="Go back to View Orders" style={{ display: 'none' }} className="btn-graph-bar pull-right" href="/schoolAdmin/viewOrders"><i class="fa fa-bar-chart"></i></a>

                            </div>
                        </div>
                        <div className="clearfix"></div>
                        <div className="row">
                            <div className="panel panel-primary">
                                <div className="panel-body">
                                    {this.state.filter === 'byStudents' ? (<Tabs selectedIndex={_tabIndex}>
                                        <TabList>
                                            <div className="pull-right">
                                                <lable style={{
                                                    padding: '12px',
                                                    fontWeight: '700',
                                                }}>Total
                                                    {this.state.action === 'NotOrdered' ? " Students" : " Orders"}: {this.state.data.length}</lable>
                                                <div id="selector" className="btn-group pull-right"
                                                    style={{ float: 'right', margin: '-7px' }}>

                                                    <button type="button" className="btn btn-xs btn-inactive-color active"
                                                        id="Ordered"
                                                        style={{ margin: 0, marginLeft: 5, fontSize: 14 }}
                                                        onClick={() => {
                                                            this.getReportsData(this.state.tabIndex, 'Ordered');
                                                            this.setState({ selectAll: false, selection: [], selectionIds: [] })
                                                        }}>Ordered
                                                    </button>
                                                    <button type="button" className="btn btn-xs btn-inactive-color"
                                                        style={{ margin: 0, marginLeft: 5, fontSize: 14 }} id="NotOrdered"
                                                        onClick={() => {
                                                            this.getReportsData(this.state.tabIndex, 'NotOrdered');
                                                            this.setState({ selectAll: false, selection: [], selectionIds: [] })
                                                        }}>Not
                                                        Ordered
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="button-group-section">
                                            </div>
                                            {gradeList.map((item) => {
                                                return <Tab onClick={() => {
                                                    this.state.tabIndex = item.value;
                                                    this.setState({ selectAll: false })
                                                    this.getReportsData(item.value, this.state.action);
                                                }} >  {item.label}</Tab>
                                            }, this)}
                                        </TabList>
                                        <TabPanel>
                                            <div className="row">
                                                <div className="col-xs-6 pull-left">
                                                    <input type="text" id="search"
                                                        className="search form-control"
                                                        style={{
                                                            float: 'left',
                                                            margin: '5px 0'
                                                        }}
                                                        name="search"
                                                        placeholder="Search.."
                                                        onKeyUp={this.filterSchool} />
                                                </div>

                                                {this.state.action === 'NotOrdered' || this.state.action === 'NotPaid' ? (
                                                    <div className="col-xs-6 pull-right button-group-section">
                                                        <button
                                                            className="btn btn-warning button-xs pull-right"

                                                            onClick={() => this.sendNotification('multiple')}
                                                            style={{
                                                                float: 'right',
                                                                margin: '5px'
                                                            }}>
                                                            <i className="fa fa-paper-plane-o"></i> Send
                                                            Reminder
                                                        </button>
                                                    </div>) :
                                                    <div className="col-xs-6 pull-right">{this.CancelBtn('multiple', undefined)}{this.RestoreBtn('multiple', undefined)}</div>
                                                }
                                            </div>
                                            {this.state.action === 'NotOrdered' || this.state.action === 'NotPaid' ? (
                                                <CheckboxTable1
                                                    ref={r => (this.checkboxTable1 = r)}
                                                    data={_.orderBy(this.state.data, ['name'], ['desc'])}
                                                    columns={this.state.columns}
                                                    defaultPageSize={10}
                                                    className="-striped -highlight"
                                                    noDataText='No data found'
                                                    {...checkboxProps}
                                                />) :
                                                (
                                                    <CheckboxTable
                                                        ref={r => (this.checkboxTable = r)}
                                                        data={this.state.data}
                                                        columns={this.state.columns}
                                                        defaultPageSize={10}
                                                        className="-striped -highlight"
                                                        noDataText='No data found'
                                                        SubComponent={(row) => {
                                                            return (
                                                                <div className="col-md-12">
                                                                    <MenuComponent row={row} date={this.state.date}
                                                                        type="student" mealType={this.state.mealType} />
                                                                </div>
                                                            )
                                                        }}
                                                        {...checkboxProps}
                                                    />)
                                            }
                                        </TabPanel>
                                        {gradeList.map(function (key) {
                                            return (
                                                <TabPanel>
                                                    <div className="row">
                                                        <div className="col-xs-6 pull-left">
                                                            <input type="text" id="search"
                                                                className="search form-control"
                                                                style={{
                                                                    float: 'left',
                                                                    margin: '5px 0'
                                                                }}
                                                                name="search"
                                                                placeholder="Search.."
                                                                onKeyUp={this.filterSchool} />
                                                        </div>
                                                        {this.state.action === 'NotOrdered' || this.state.action === 'NotPaid' ? (
                                                            <div className="col-xs-6 pull-right button-group-section">
                                                                <button
                                                                    className="btn btn-warning button-xs pull-right"
                                                                    onClick={() => this.sendNotification('multiple')}
                                                                    style={{
                                                                        float: 'right',
                                                                        margin: '5px'
                                                                    }}>
                                                                    <i className="fa fa-paper-plane-o"></i> Send
                                                                    Reminder
                                                                </button>
                                                                {(this.state.action === 'NotPaid') ?
                                                                    this.CancelBtn('multiple', undefined)

                                                                    : null}

                                                            </div>) :
                                                            (this.state.action === 'Ordered') ?
                                                                <div className="col-xs-6 pull-right">{this.CancelBtn('multiple', undefined)}{this.RestoreBtn('multiple', undefined)}</div>

                                                                : null

                                                        }

                                                    </div>
                                                    {this.state.action === 'NotOrdered' || this.state.action === 'NotPaid' ? (
                                                        <CheckboxTable1
                                                            ref={r => (this.checkboxTable1 = r)}
                                                            data={_.orderBy(this.state.data, ['name'], ['desc'])}
                                                            columns={this.state.columns}
                                                            defaultPageSize={10}
                                                            className="-striped -highlight"
                                                            noDataText='No data found'
                                                            {...checkboxProps}
                                                        />) :

                                                        this.state.action === 'Ordered' ?
                                                            <CheckboxTable
                                                                ref={r => (this.checkboxTable = r)}
                                                                data={_.orderBy(this.state.data, ['orderDateTime'], ['desc'])}
                                                                columns={this.state.columns}
                                                                defaultPageSize={10}
                                                                className="-striped -highlight"
                                                                noDataText='No data found'
                                                                defaultSorting={[{
                                                                    id: 'orderDateTime',
                                                                    desc: false
                                                                }]}

                                                                SubComponent={(row) => {
                                                                    return (
                                                                        <div className="col-md-12">
                                                                            <MenuComponent row={row} date={this.state.date}
                                                                                type="student" mealType={this.state.mealType} />
                                                                        </div>
                                                                    )
                                                                }}
                                                                {...checkboxProps}
                                                            />
                                                            :
                                                            <ReactTable
                                                                data={_.orderBy(this.state.data, ['orderDateTime'], ['desc'])}
                                                                columns={this.state.columns}
                                                                defaultPageSize={10}
                                                                className="-striped -highlight"
                                                                noDataText='No data found'
                                                                sortable={true}
                                                                defaultSorting={[{
                                                                    id: 'orderDateTime',
                                                                    desc: false
                                                                }]}
                                                                SubComponent={(row) => {
                                                                    return (
                                                                        <div className="col-md-12">
                                                                            <MenuComponent row={row} date={this.state.date}
                                                                                type="student" mealType={this.state.mealType} />
                                                                        </div>
                                                                    )
                                                                }}
                                                                {...checkboxProps}
                                                            />
                                                    }
                                                </TabPanel>)
                                        }, this)}
                                    </Tabs>) : (<div style={{ margin: '10px' }}>
                                        <Tabs>
                                            <TabList>
                                                <Tab>Items for
                                                    : {moment(this.state.date).format(date_format())}</Tab>
                                            </TabList>
                                            <TabPanel>
                                                <ReactTable
                                                    data={_.orderBy(this.state.data, ['itemName'], ['asc'])}
                                                    columns={this.state.columns}
                                                    defaultPageSize={10}
                                                    className="-striped -highlight"
                                                    noDataText='No data found'
                                                    {...checkboxProps}
                                                />
                                            </TabPanel> </Tabs>
                                    </div>)}
                                </div>
                            </div>
                        </div>
                    </div>

                </section>
                <Modal
                    isOpen={this.state.cancelModal}
                    //onRequestClose={() => this.setState({cancelModal: false})}
                    style={modalStyles}
                    contentLabel="Activation"
                    ariaHideApp={false}
                >
                    <div className="modal-header">
                        <h4 className="modal-title modal-title-color" id="deleteLabel">Cancel order for selected date</h4>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="form-group uploadFileInfo col-md-12 createmenu-month-group">
                                <label className="custom-label">Select date*</label>
                                <div className="input-group col-md-12 col-sm-12 col-xs-12">
                                    <Datetime id='cancelOIDateTime' dateFormat="YYYY-MM-DD" timeFormat={false}
                                        inputProps={{ readOnly: true }} closeOnSelect={true} renderInput={this.renderInput}
                                        onChange={(e) => {
                                            const cancelSelectedData = this.state.cancelSelectedData;
                                            let d = new Date(e);
                                            year = d.getFullYear();
                                            month = ('0' + (d.getMonth() + 1)).slice(-2);
                                            day = ('0' + d.getDate()).slice(-2);
                                            cancelSelectedData.cancelDate = year + '-' + month + '-' + day;
                                            cancelSelectedData._cancelDate = d;
                                            this.setState({ cancelSelectedData: cancelSelectedData });
                                        }}
                                        isValidDate={(current) => {
                                            let firstDay = new Date(this.state.date.getFullYear(), this.state.date.getMonth(), 1);
                                            let lastDay = new Date(firstDay.getFullYear(), firstDay.getMonth() + 1, 0);
                                            if (firstDay <= new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())) {

                                                firstDay = (moment().isAfter(moment('10:00a', "HH:mm a"))) ? new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1) : new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
                                            }
                                            const activeInstantPayment = getAccessLevelByModule(modEnum.IPFO) ? true : false
                                            if (activeInstantPayment) {
                                                if (current >= new Date(this.state.date.getFullYear(), this.state.date.getMonth(), 1) && current <= lastDay) {
                                                    if (current.day() != 6 && current.day() != 0)
                                                        return true;
                                                    else
                                                        return false;
                                                } else {
                                                    return false;

                                                }
                                            } else {
                                                if (current >= firstDay && current <= lastDay)
                                                    if (current.day() != 6 && current.day() != 0)
                                                        return true;
                                                    else
                                                        return false;
                                                else {
                                                    return false
                                                }
                                            }
                                        }} />
                                </div></div>

                            <div className="form-group col-md-12">
                                <label className="control-label" >Reason for cancellation*</label>
                                <input className="form-control" name="reason" id="cancelOIReason"
                                    placeholder=""
                                    required onChange={(e) => {
                                        const cancelSelectedData = this.state.cancelSelectedData;
                                        cancelSelectedData.reason = e.target.value;
                                        this.setState({ cancelSelectedData: cancelSelectedData });
                                    }} />



                            </div>
                            <div className="col-md-12 text-right">
                                <button type="button" className="btn btn-primary btn-xs" style={{ margin: '0' }}
                                    onClick={() => {
                                        const cancelSelectedData = this.state.cancelSelectedData
                                        cancelSelectedData.reason = '';
                                        this.setState({ cancelModal: false, cancelSelectedData })
                                    }}><i
                                        className="glyphicon glyphicon-remove"
                                        style={{ marginRight: '0', paddingLeft: '0' }}></i> Cancel
                                </button>
                                <CustomSubmit type="button" className="btn btn-success btn-xs"
                                    style={{ margin: '0 0 0 5px' }}
                                    id="deleteConfirm" handleSubmit={(e, callback) => this.getCancel_OrdersCount(callback)} >
                                    <i className="glyphicon glyphicon-ok"></i> Ok
                                </CustomSubmit>
                            </div>
                        </div>
                    </div>
                </Modal>

                <Modal
                    isOpen={this.state.restoreModal}
                    // onRequestClose={() => this.setState({restoreModal: false})}
                    style={modalStyles}
                    contentLabel="Activation"
                    ariaHideApp={false}
                >
                    <div className="modal-header">
                        <h4 className="modal-title modal-title-color" id="deleteLabel">Restore cancelled order item</h4>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="form-group uploadFileInfo col-md-12 createmenu-month-group">
                                <label className="custom-label">Select date*</label>
                                <div className="input-group col-md-12 col-sm-12 col-xs-12">
                                    <Datetime id='restoreOIDateTime' dateFormat="YYYY-MM-DD" timeFormat={false}
                                        inputProps={{ readOnly: true }} closeOnSelect={true} renderInput={this.renderInput}
                                        onChange={(e) => {
                                            const restoreSelectedData = this.state.restoreSelectedData;
                                            let d = new Date(e);
                                            year = d.getFullYear();
                                            month = ('0' + (d.getMonth() + 1)).slice(-2);
                                            day = ('0' + d.getDate()).slice(-2);
                                            restoreSelectedData.restoreDate = year + '-' + month + '-' + day;
                                            restoreSelectedData._restoreDate = d;
                                            this.setState({ restoreSelectedData: restoreSelectedData });
                                        }}
                                        isValidDate={(current) => {
                                            let firstDay = new Date(this.state.date.getFullYear(), this.state.date.getMonth(), 1);
                                            let lastDay = new Date(firstDay.getFullYear(), firstDay.getMonth() + 1, 0);
                                            if (firstDay <= new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())) {
                                                // Allow restoring today's cancellations as well as future dates.
                                                firstDay = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
                                            }
                                            if (current >= firstDay && current <= lastDay)
                                                if (current.day() != 6 && current.day() != 0)
                                                    return true;
                                                else
                                                    return false;
                                            else {
                                                return false
                                            }
                                        }} />
                                </div></div>

                            <div className="form-group col-md-12">
                                <label className="control-label" >Reason for restore cancelled order Item*</label>
                                <input className="form-control" name="reason" id="restoreOIReason" value={this.state.restoreSelectedData.reason || ''}
                                    placeholder=""
                                    required onChange={(e) => {
                                        const restoreSelectedData = this.state.restoreSelectedData;
                                        restoreSelectedData.reason = e.target.value;
                                        this.setState({ restoreSelectedData: restoreSelectedData });
                                    }} />



                            </div>
                            <div className="col-md-12 text-right">
                                <button type="button" className="btn btn-primary btn-xs" style={{ margin: '0' }}
                                    onClick={() => this.setState({ restoreModal: false })}><i
                                        className="glyphicon glyphicon-remove"
                                        style={{ marginRight: '0', paddingLeft: '0' }}></i> Cancel
                                </button>
                                <CustomSubmit type="button" className="btn btn-success btn-xs"
                                    style={{ margin: '0 0 0 5px' }}
                                    id="deleteConfirm" handleSubmit={(e, callback) => this.getRestore_OrdersCount(callback)} >
                                    <i className="glyphicon glyphicon-ok"></i> Ok
                                </CustomSubmit>
                            </div>
                        </div>
                    </div>
                </Modal>
                <Modal
                    isOpen={this.state.historyModal}
                    // onRequestClose={() => this.setState({historyModal: false})}
                    style={historymodalStyles}
                    contentLabel="Activation"
                    ariaHideApp={false}>
                    <div className="modal-header row">
                        <h4 className="modal-title modal-title-color col-md-6" id="deleteLabel">Order log</h4>
                        <div className="col-md-6"><button type="button" className="pull-right color-1" onClick={() => this.closeHistory()}>X</button></div>
                    </div>
                    <div className="modal-body" style={{ maxHeight: '350px', overflowY: 'scroll' }}>
                        <div className="row">
                            <ReactTable
                                key={this.state.history_Count}
                                data={this.state.historydata}
                                defaultPageSize={this.state.history_Count}
                                showPagination={false}
                                columns={[{
                                    //accessor: 'createdOn',
                                    Header: 'Date',
                                    Cell: ({ row }) => <span>{moment(row._original.createdOn).format(date_format() + ' ' + 'hh:mm:ss a')}</span>,
                                    style: { textAlign: 'center' },
                                    width: 200
                                },
                                {
                                    accessor: 'createdBy',
                                    Header: 'User',
                                    style: { textAlign: 'center' }
                                    , width: 200
                                },
                                {
                                    accessor: 'items_count',
                                    Header: 'Count',
                                    style: { textAlign: 'center' },
                                    width: 100

                                },
                                {
                                    accessor: 'orderAmount',
                                    Header: 'Amount',
                                    style: { textAlign: 'center' },
                                    Cell: ({ row }) => {
                                        const totAmt = (numberParce(row._original.orderAmount) + numberParce(row._original.salesTaxAmt))
                                        return (
                                            <span style={{ textAlign: 'right' }}>
                                                {currency_symbol() + ' ' + convertTwoDecimalPoint(totAmt)} </span>)
                                    },
                                    width: 100
                                },
                                {
                                    accessor: 'crudOperationVal',
                                    Header: 'Status',
                                    style: { textAlign: 'center' },
                                    Cell: ({ row }) => (
                                        <span style={{ textAlign: 'right' }}>
                                            {row._original.crudOperationVal == 0 ? 'Created' : row._original.crudOperationVal == 1 ? 'Modified' : row._original.crudOperationVal == 2 ? 'Cancelled' : 'Restored'} </span>),
                                    width: 100
                                },
                                {
                                    accessor: 'cancellationNote',
                                    Header: 'Cancel Reason',
                                    style: { textAlign: 'center' },
                                    Cell: ({ row }) => (
                                        <span style={{ textAlign: 'right' }}>
                                            {row._original.cancellationNote} </span>),
                                }]}
                                className="-striped -highlight"
                                noDataText='No data found'
                                {...checkboxProps}
                            />
                        </div>
                    </div>
                </Modal>
                <Modal
                    isOpen={this.state.cancelConformModal}
                    // onRequestClose={() => this.setState({cancelConformModal: false})}
                    style={modalStyles}
                    contentLabel="Activation"
                    ariaHideApp={false}
                >
                    <div className="modal-header">
                        <h4 className="modal-title modal-title-color" id="deleteLabel">Confirmation for cancel order</h4>
                    </div>
                    <div className="modal-body">
                        <p>
                            {`
                            You have selected ${this.state.selectionIds.length}  ${this.state.selectionIds.length > 1 ? 'students' : 'student'} having ${this.state.cancelOrdersCount} ${numberParce(this.state.cancelOrdersCount) > 1 ? 'orders' : 'order'} on the date of  ${this.state.cancelSelectedData.cancelDate}.
                            `}
                        </p>
                        {numberParce(this.state.cancelOrdersCount) > this.state.selectionIds.length ? (
                            <p style={{ color: '#d9534f', fontWeight: 'bold' }}>
                                {`Warning: ${this.state.cancelOrdersCount} orders is more than the ${this.state.selectionIds.length} selected ${this.state.selectionIds.length > 1 ? 'students' : 'student'}. Please verify before continuing.`}
                            </p>
                        ) : null}
                        <p>{`
                        The cancellation reason provided is ${document.getElementById('cancelOIReason') && document.getElementById('cancelOIReason').value || ''}.
                        `}</p>
                        <p>Are you sure you want to continue with the order cancellation?</p>

                    </div>
                    <div className="text-right">
                        <button type="button" className="btn btn-primary btn-xs" style={{ margin: '0' }}
                            onClick={() => {
                                const cancelSelectedData = this.state.cancelSelectedData;
                                cancelSelectedData.reason = ''
                                this.setState({ cancelConformModal: false })
                            }}><i
                                className="glyphicon glyphicon-remove"
                                style={{ marginRight: '0', paddingLeft: '0' }}></i> Cancel
                        </button>
                        <CustomSubmit type="button" className="btn btn-success btn-xs"
                            style={{ margin: '0 0 0 5px' }}
                            id="deleteConfirm" handleSubmit={(e, callback) => this.cancelOrderItensSubmit(false, callback)} >
                            <i className="glyphicon glyphicon-ok"></i> Ok
                        </CustomSubmit>
                    </div>
                </Modal>

                <Modal
                    isOpen={this.state.restoreConformModal}
                    // onRequestClose={() => this.setState({restoreConformModal: false})}
                    style={modalStyles}
                    contentLabel="Activation"
                    ariaHideApp={false}
                >
                    <div className="modal-header">
                        <h4 className="modal-title modal-title-color" id="deleteLabel">Confirmation for restore cancelled item</h4>
                    </div>
                    <div className="modal-body">
                        <p>Are you sure you want to restore cancelled item for selected date ({this.state.restoreSelectedData.restoreDate})?</p>
                        <p>Restore orders: {`${this.state.restoreOrdersCount}`}</p>
                    </div>
                    <div className="text-right">
                        <button type="button" className="btn btn-primary btn-xs" style={{ margin: '0' }}
                            onClick={() => this.setState({ restoreConformModal: false })}><i
                                className="glyphicon glyphicon-remove"
                                style={{ marginRight: '0', paddingLeft: '0' }}></i> Cancel
                        </button>
                        <CustomSubmit type="button" className="btn btn-success btn-xs"
                            style={{ margin: '0 0 0 5px' }}
                            id="deleteConfirm" handleSubmit={(e, callback) => this.restoreOrderItensSubmit(false, callback)} >
                            <i className="glyphicon glyphicon-ok"></i> Ok
                        </CustomSubmit>
                    </div>
                </Modal>

            </div>
        )
    }
}

ordersGrid.contextTypes = {
    router: PropTypes.object.isRequired
}
export default ordersGrid




// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Reports/ordersGrid.js